module.exports = __webpack_public_path__ + "static/media/office-4.b1d0e6f8.jpg";